import React, { useEffect, useState } from 'react';

import api from '../../services/api.js';
import FormConsultores from "./Components/Consultores/Form/FormConsultores.js";
import TableConsultores from "./Components/Consultores/Table/TableConsultores.js";
import FormFornecedores from "./Components/Fornecedores/Form/FormFornecedores";
import TableFornecedores from "./Components/Fornecedores/Table/TableFornecedores.js";
import FormRecursoMaterial from "./Components/RecursoMaterial/Form/FormRecursoMaterial.js";
import TableRecursoMaterial from "./Components/RecursoMaterial/Table/TableRecursoMaterial.js";
import MyAppBar from "../MyAppBar/MyAppBar.js";

export default function Contacts() {
    const [openC, setOpenC] = useState(false)
    const [dataC, setDataC] = useState(null)
    const [reloadC, setReloadC] = useState(false);

    const [openF, setOpenF] = useState(false)
    const [dataF, setDataF] = useState(null)
    const [reloadF, setReloadF] = useState(false);

    const [openR, setOpenR] = useState(false)
    const [dataR, setDataR] = useState(null)
    const [reloadR, setReloadR] = useState(false);

    const [list_usinas, setListUsinas] = useState([]);

    // buscando usinas
    useEffect(() => {
        async function fetchData() {
            api.get(`/usinas`)
                .then((res) => {
                    setListUsinas(res.data)
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        fetchData();
    }, []);

    return (
        <>
            < MyAppBar />
            < TableConsultores reload={reloadC} setOpen={setOpenC} setData={setDataC} setReload={setReloadC} />
            < FormConsultores data={dataC} open={openC} setOpen={setOpenC} setReload={setReloadC} />

            < TableFornecedores reload={reloadF} setOpen={setOpenF} setData={setDataF} setReload={setReloadF} />
            < FormFornecedores data={dataF} open={openF} setOpen={setOpenF} setReload={setReloadF} list_usinas={list_usinas} />

            < TableRecursoMaterial reload={reloadR} setOpen={setOpenR} setData={setDataR} setReload={setReloadR} />
            < FormRecursoMaterial data={dataR} open={openR} setOpen={setOpenR} setReload={setReloadR} list_usinas={list_usinas} />
        </>
    );
}
